var eventBus = new Vue();
var loginUrl = "/account/login";

Number.isInteger = Number.isInteger || function (value)
{
  return typeof value === "number" &&
    isFinite(value) &&
    Math.floor(value) === value;
};

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find)
{
  Object.defineProperty(Array.prototype, "find",
    {
      value: function (predicate)
      {
        // 1. Let O be ? ToObject(this value).
        if (this === null)
        {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== "function")
        {
          throw new TypeError("predicate must be a function");
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len)
        {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];

          if (predicate.call(thisArg, kValue, k, o))
          {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      },
      configurable: true,
      writable: true
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex)
{
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function (predicate)
    {
      // 1. Let O be ? ToObject(this value).
      if (this === null)
      {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function')
      {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len)
      {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o))
        {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}

if (!String.prototype.endsWith)
{
  String.prototype.endsWith = function (search, this_len)
  {
    if (this_len === undefined || this_len > this.length)
    {
      this_len = this.length;
    }

    return this.substring(this_len - search.length, this_len) === search;
  };
}

if (!Array.prototype.filter)
{
  Array.prototype.filter = function(func, thisArg)
  {
    "use strict";

    if (!((typeof func === "Function" || typeof func === "function") && this))
    {
      throw new TypeError();
    }

    var len = this.length >>> 0;
    var result = new Array(len);
    var t = this;
    var c = 0;
    var i = -1;

    if (thisArg === undefined)
    {
      while (++i !== len)
      {
        if (i in this)
        {
          if (func(t[i], i, t))
          {
            result[c++] = t[i];
          }
        }
      }
    }
    else
    {
      while (++i !== len)
      {
        if (i in this)
        {
          if (func.call(thisArg, t[i], i, t))
          {
            result[c++] = t[i];
          }
        }
      }
    }

    result.length = c;

    return result;
  };
}

function isInputTypeSupported(inputType)
{
  var input = document.createElement("input");
  var value = "a";

  input.setAttribute("type", inputType);
  input.setAttribute("value", value);

  return (input.value !== value);
}

function formatString(text, jsonObj)
{
  if (jsonObj === undefined || jsonObj === null)
  {
    return text;
  }

  var pattern = new RegExp(/\{([^}]+)\}/g);
  var result = text;

  if (pattern.test(text))
  {
    var matches = text.match(pattern);

    Object.keys(jsonObj).forEach(function (key, index)
    {
      for (var i = 0; i < matches.length; i++)
      {
        if (("{" + key + "}") === matches[i])
        {
          result = result.replace(new RegExp(matches[i], "g"), jsonObj[key]);
        }
      }
    });
  }    

  return result;
}

function debounce(func, wait, immediate)
{
  var timeout;

  return function ()
  {
    var context = this;
    var args = arguments;

    var later = function ()
    {
      timeout = null;

      if (!immediate)
      {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow)
    {
      func.apply(context, args);
    }
  };
}

function throttle(func, limit)
{
  var lastFunc;
  var lastRan;

  return function()
  {
    var context = this;
    var args = arguments;

    if (!lastRan)
    {
      func.apply(context, args);
      lastRan = Date.now();
    }
    else
    {
      clearTimeout(lastFunc);

      lastFunc = setTimeout(function()
      {
        if ((Date.now() - lastRan) >= limit)
        {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

function limitText(value, max)
{
  if (value && typeof value === "string")
  {
    if (value.length > max)
    {
      return value.substr(0, max - 3) + "...";
    }
  }

  return value;
}

function formatBool(value, trueString, falseString)
{
  if (typeof value === "boolean")
  {
    if (value)
    {
      return trueString;
    }

    return falseString;
  }

  if (value)
  {
    return value.toString();
  }

  return null;
}

function formatDateTime(value, format)
{
  if (value && typeof value === "string")
  {
    if (format && typeof format === "string" && format !== "")
    {
      return moment(value).format(format);
    }

    return moment(value).format("DD/MM/YYYY HH:mm");
  }

  return value;
}

function gotoLogin(url, querystring)
{
  var returnUrl = "";

  if (url && url !== null && url !== "")
  {
    if (querystring && querystring !== null && querystring !== "")
    {
      returnUrl = "?returnUrl=" + encodeURIComponent(url + querystring);
    }
    else
    {
      returnUrl = "?returnUrl=" + encodeURIComponent(url);
    }
  }

  window.location.href = loginUrl + returnUrl;
}

Vue.filter("formatFileSize", function (value)
{
  if (value && typeof value === "number")
  {
    var size = 0;
    var unit = "MB";

    if (value >= 1048576)
    {
      size = value / (1024 * 1024);
    }
    else
    {
      size = value / 1024;
      unit = "kB";
    }

    if (Number.isInteger(size))
    {
      return size + unit;
    }
    else
    {
      return size.toFixed(2) + unit;
    }
  }

  return value;
});

Vue.filter("formatCurrency", function (value)
{
  if (typeof value === "number")
  {
    return "£ " + value.toFixed(2);
  }

  return value;
});

Vue.filter("formatDateTime", function (value)
{
  if (value && typeof value === "string")
  {
    return moment(value).format("DD/MM/YYYY HH:mm");
  }

  return value;
});

Vue.filter("formatDate", function (value)
{
  if (value && typeof value === "string")
  {
    return moment(value).format("DD/MM/YYYY");
  }

  return value;
});

Vue.filter("formatTime", function (value)
{
  if (value && typeof value === "string")
  {
    return moment(value).format("HH:mm");
  }

  return value;
});

Vue.filter("formatYesNo", function (value)
{
  return formatBool(value, "Yes", "No");
});

Vue.filter("formatEnabled", function (value)
{
  return formatBool(value, "Enabled", "Disabled");
});

Vue.filter("limitText", function (value)
{
  if (value && typeof value === "string")
  {
    if (value.length > 50)
    {
      return value.substr(0, 47) + "...";
    }
  }

  return value;
});

Vue.component("paging-item",
  {
    template: "#paging-template",
    props:
      {
        page: Number,
        pages: Number,
        count: Number
      },
    computed:
    {
      hasItems: function ()
      {
        return this.count > 0;
      },
      canPage: function ()
      {
        return this.pages > 1;
      },
      onFirstPage: function ()
      {
        return this.page === 1;
      },
      onLastPage: function ()
      {
        return this.page === this.pages;
      }
    },
    methods:
    {
      gotoFirstPage: function () { this.$emit("goto-page", 1); },
      gotoPrevPage: function () { this.$emit("goto-page", (this.page - 1)); },
      gotoNextPage: function () { this.$emit("goto-page", (this.page + 1)); },
      gotoLastPage: function () { this.$emit("goto-page", this.pages); }
    }
  });

Vue.component("recordcount-item",
  {
    template: "#recordcount-template",
    props:
      {
        page: Number,
        pages: Number,
        count: Number,
        name: String
      },
    computed:
      {
        hasItems: function ()
        {
          return this.count > 0;
        }
      }
  });

Vue.component("notification-item",
  {
    template: "#notification-template",
    props:
    {
      id: { type: String, required: false, default: "notification" },
      fixable: { type: Boolean, required: false, default: true }
    },
    data: function ()
    {
      return { message: null, items: [], success: false, error: false, notSeen: false, fixed: false };
    },
    created: function ()
    {
      eventBus.$on("notify-success", this.showSuccess);
      eventBus.$on("notify-error", this.showError);
      eventBus.$on("notify-clear", this.clear);
      eventBus.$on("notify-fix", this.fix);
    },
    beforeDestroy: function ()
    {
      eventBus.$off("notify-success", this.showSuccess);
      eventBus.$off("notify-error", this.showError);
      eventBus.$off("notify-clear", this.clear);
      eventBus.$off("notify-fix", this.fix);
    },
    mounted: function ()
    {
      if (this.fixable)
      {
        if (bodyTop === undefined)
        {
          bodyTop = $("#body-container").offset().top;
        }

        window.addEventListener("scroll", notificationScroll);
      }
    },
    computed:
    {
      hasMessage: function ()
      {
        return this.success || this.error;
      },
      
      hasItems: function ()
      {
        return this.items.length > 0;
      }
    },
    methods:
    {
      fix: function(value, id)
      {
        if (this.fixable && (id === undefined || id === this.id))
        {
          this.fixed = value;
        }
      },

      clear: function(id)
      {
        if (id === undefined || id === this.id)
        {
          this.error = false;
          this.success = false;
          this.message = null;
          this.notSeen = false;

          if (this.items.length > 0)
          {
            this.items.splice(0, this.items.length);
          }
        }
      },

      showSuccess: function(message, id)
      {
        if (message !== undefined && message !== null && (id === undefined || id === this.id))
        {
          this.error = false;
          this.success = true;
          this.message = message;

          if (this.items.length > 0)
          {
            this.items.splice(0, this.items.length);
          }

          this.notSeen = this.fixed;
        }
      },

      showError: function(error, id)
      {
        if (error !== undefined && error !== null && (id === undefined || id === this.id))
        {
          this.success = false;
          this.error = true;

          if (this.items.length > 0)
          {
            this.items.splice(0, this.items.length);
          }

          if (typeof error === "string")
          {
            this.message = error;
            return;
          }

          if (error.message !== undefined && error.message !== null)
          {
            this.message = error.message;
          }

          if (error.errors !== undefined && error.errors !== null)
          {
            if (typeof error.errors === "string")
            {
              this.items.push(error.errors);
            }
            else if (error.errors.constructor === Array && error.errors.length > 0)
            {
              var thisObj = this;

              error.errors.forEach(function (errorItem)
              {
                if (typeof errorItem === "string")
                {
                  thisObj.items.push(errorItem);
                }
                else
                {
                  Object.keys(error.errors).forEach(function (key, index)
                  {
                    if (error.errors[key] === "string")
                    {
                      thisObj.items.push(error.errors[key]);
                    }
                    else
                    {
                      error.errors[key].forEach(function (item)
                      {
                        thisObj.items.push(item);
                      });
                    }
                  });
                }
              });
            }
          }

          this.notSeen = this.fixed;
        }   
      },

      notificationSeen: function()
      {
        this.notSeen = false;
      }
    }
  });
    
Vue.component("modal-item",
  {
    template: "#modal-template",
    props:
      {
        id: String,
        title: String,
        text: String,
        confirmText: String,
        confirmType: String,
        cancelText: String
      },
    data: function ()
    {
      return { eventInfo: null, dialogText: null, confirmPrimary: false, confirmSecondary: false, confirmSuccess: false, confirmWarning: false, confirmDanger: false };
    },
    created: function ()
    {
      if (this.confirmType === null || this.confirmType === "primary")
      {
        this.confirmPrimary = true;
      }
      else if (this.confirmType === "secondary")
      {
        this.confirmSecondary = true;
      }
      else if (this.confirmType === "success")
      {
        this.confirmSuccess = true;
      }
      else if (this.confirmType === "warning")
      {
        this.confirmWarning = true;
      }
      else if (this.confirmType === "danger")
      {
        this.confirmDanger = true;
      }

      this.dialogText = this.text;

      eventBus.$on("show-modal", this.show);
    },
    beforeDestroy: function ()
    {
      eventBus.$off("show-modal", this.show);
    },
    methods:
      {
        confirmed: function ()
        {
          $("#" + this.id).modal("hide");

          if (this.eventInfo !== null)
          {
            this.$emit("confirmed", JSON.parse(this.eventInfo));
          }
          else
          {
            this.$emit("confirmed");
          }
        },

        cancelled: function ()
        {
          $("#" + this.id).modal("hide");

          if (this.eventInfo !== null)
          {
            this.$emit("cancelled", JSON.parse(this.eventInfo));
          }
          else
          {
            this.$emit("cancelled");
          }
        },

        show: function (e)
        {
          if (e.id === this.id)
          {
            if (e.info && e.info !== null)
            {
              this.eventInfo = JSON.stringify(e.info);
              this.dialogText = formatString(this.text, e.info);
            }
            else
            {
              this.eventInfo = null;
            }

            $("#" + this.id).modal("show");
          }
        }
      }
    });

Vue.component("actoast-item",
  {
    template: "#actoast-template",
    props:
    {
      toast: { type: Object, required: true }
    },
    mounted: function()
    {
      if (this.toast.autoHide)
      {
        var hideId = this.toast.id;

        setTimeout(function() { eventBus.$emit("toast-hide", hideId); }, 8000 );
      }
    },
    computed:
    {
      hasMessage: function ()
      {
        return (this.toast.message && this.toast.message !== "");
      },

      hasMessages: function ()
      {
        return this.toast.messages && this.toast.messages.constructor === Array && this.toast.messages.length > 0;
      },

      hasUrl: function ()
      {
        return (this.toast.url.href && this.toast.url.href !== "");
      }
    },
    methods:
    {
      close: function()
      {
        eventBus.$emit("toast-close", this.toast.id);
      }
    }
  });

Vue.component("actoasts-item",
  {
    template: "#actoasts-template",
    data: function()
    {
      return { seq: 0, items: [] };
    },
    created: function ()
    {
      eventBus.$on("toast-show", this.show);
      eventBus.$on("toast-hide", this.hide);
      eventBus.$on("toast-close", this.close);
    },
    beforeDestroy: function ()
    {
      eventBus.$off("toast-show", this.show);
      eventBus.$off("toast-hide", this.hide);
      eventBus.$off("toast-close", this.close);
    },
    computed:
    {
      hasItems: function()
      {
        return this.items.length > 0;
      }     
    },
    methods:
    {
      show: function(info)
      {
        this.seq++;

        var item =
            {
              id: this.seq,
              title: info.title,
              message: info.message,
              messages: info.messages,
              url: { href: null, text: null },
              onClose: info.onClose,
              autoHide: true
            };

        if (info.url)
        {
          item.url.href = info.url.href;

          if (info.url.text && info.url.text !== "")
          {
            item.url.text = info.url.text;
          }
          else
          {
            item.url.text = info.url.href;
          }
        }

        if (info.autoHide !== undefined && info.autoHide !== null)
        {
          item.autoHide = info.autoHide;
        }

        this.items.push(item);
      },

      hide: function(id)
      {
        var index = this.items.findIndex(function (item) { return item.id === id; });

        if (index !== -1)
        {
          this.items.splice(index, 1);
        }
      },

      close: function(id)
      {
        var index = this.items.findIndex(function (item) { return item.id === id; });

        if (index !== -1)
        {
          if (this.items[index].onClose && (typeof this.items[index].onClose === "function"))
          {
            this.items[index].onClose.call();
          }

          this.items.splice(index, 1);
        }
      }
    }
  });
  
var getObject = function(action, headers)
{
  return new Promise(function(resolve, reject)
  {
    $.ajax(
      {
        type: "GET",
        url: action,
        contentType: "application/json; charset=utf-8",
        headers: headers,
        async: true
      })
      .fail(function (jqxhr, textStatus, errorThrown)
      {
        if (jqxhr.status === 401)
        {
          gotoLogin(window.location.pathname, window.location.search);
        }
        else
        {
          reject(getJqxhrError(jqxhr, "There was a problem with the request."));
        }
      })
      .done(function (data)
      {
        resolve(data);
      })
      .always(function ()
      {
      });
  });
};

var submitForm = function(action, method, headers, json)
{
  return new Promise(function(resolve, reject)
  {
    var formMethod = method;

    if (formMethod === "PUT")
    {
      formMethod = "POST";
    }

    $.ajax(
      {
        type: formMethod,
        url: action,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: json,
        headers: headers,
        async: true
      })
      .fail(function (jqxhr, textStatus, errorThrown)
      {
        if (jqxhr.status === 401)
        {
          gotoLogin(window.location.pathname, window.location.search);
        }
        else
        {
          reject(getJqxhrError(jqxhr, "There was a problem with the request."));
        }
      })
      .done(function (data)
      {
        resolve(data);
      })
      .always(function ()
      {
      });
  });
};

var deleteObject = function (action, headers)
{
  return new Promise(function (resolve, reject)
  {
    $.ajax(
      {
        type: "DELETE",
        url: action,
        headers: headers,
        async: true
      })
      .fail(function (jqxhr, textStatus, errorThrown)
      {
        if (jqxhr.status === 401)
        {
          gotoLogin(window.location.pathname, window.location.search);
        }
        else
        {
          reject(getJqxhrError(jqxhr, "There was a problem with the request."));
        }
      })
      .done(function (data)
      {
        resolve(data);
      })
      .always(function ()
      {
      });
  });
};

function getJqxhrError(jqxhr, defaultMessage)
{
  var result = defaultMessage;

  if (jqxhr.status === 404)
  {
    result = "URL not found.";
  }
  else if (jqxhr.responseJSON && jqxhr.responseJSON !== null)
  {
    result = jqxhr.responseJSON;
  }
  else if (jqxhr.responseText && jqxhr.responseText !== null)
  {
    result = jqxhr.responseText;
  }
  else
  {
    result = "System error (it has been logged).";
  }

  return result;
}

var bodyTop;
var notificationFixed = false;
//var notificationBusy = false;
var angelShown = false;
var windowWidth = 0;

var notificationScroll = throttle(function ()
{
  var windowTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

  $(".notification-wrapper.fixable").each(function ()
  {
    var elementTop = windowTop;

    if ($(this).is(":visible"))
    {
      elementTop = $(this).offset().top;
    }
    else if ($(this).prev(":visible").length === 1)
    {
      elementTop = $(this).parent().offset().top;
    }
    else
    {
      elementTop = $(this).parent().offset().top;
    }

    if (windowTop > elementTop && !notificationFixed)
    {
      //if (!notificationFixed)
      //{
        //notificationBusy = true;
        notificationFixed = true;
        //$(this).css("height", $(this).height() + "px");
        eventBus.$emit("notify-fix", true);
        console.log("notification should be stuck");
        console.log("elementTop = " + elementTop);
        console.log("windowTop = " + windowTop);
        //notificationBusy = false;
      //}
    }
    else if (windowTop < (elementTop + 1) && notificationFixed)
    {
      //notificationBusy = true;
      notificationFixed = false;
      eventBus.$emit("notify-fix", false);
      //$(this).css("height", "auto");
      console.log("notification should be unstuck");
      //notificationBusy = false;
    }
  });
}, 25);

function toggleMenu()
{
  var menu = document.getElementById("main-nav-menu");
  var nav = document.getElementById("main-nav");

  if (menu.classList.contains("slide-up"))
  {
    menu.classList.remove("slide-up");
    menu.classList.add("slide-down");
    nav.classList.remove("slide-up");
    nav.classList.add("slide-down");
  }
  else
  {
    menu.classList.remove("slide-down");
    menu.classList.add("slide-up");
    nav.classList.remove("slide-down");
    nav.classList.add("slide-up");
  }

  return false;
}

function clearLoading()
{
  var elements = document.getElementsByClassName("vloading");

  for (var i = 0, l = elements.length; i !== l; i++) {
    elements[0].classList.remove("vloading");
  }
}

document.getElementById("main-nav-button").onclick = toggleMenu;

var wrappers = document.getElementsByClassName("cssload-wrapper");

for (var wrapIndex = 0, wrapLength = wrappers.length; wrapIndex !== wrapLength; wrapIndex++)
{
  if (wrappers[wrapIndex].parentElement)
  {
    wrappers[wrapIndex].parentElement.style.position = "relative";
  }
}

wrappers = null;